import { Grid } from '@material-ui/core';
import React from 'react';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { TransactionResult } from './interfaces/transaction-search-response';
import { transactionSearchModalStyles } from './transaction-based-return-styles';
import moment from 'moment';
interface TransactionSearchResultListingProps {
  listing: TransactionResult;
  selected: boolean;
  onSelect: (selectedTransaction: TransactionResult) => void;
  testIdPrefix: string;
}

export const TransactionSearchResultListings = (
  props: TransactionSearchResultListingProps,
): JSX.Element => {
  const classes = transactionSearchModalStyles();
  const { listing, selected, onSelect, testIdPrefix } = props;
  const { grandAmount, siteInfoId, touchPointId, closeDateTimeUtc, transactionNumber } = listing;
  const className = `result ${selected ? `${classes.selected}` : ''}`;

  return (
    <Grid
      direction='column'
      spacing={0}
      wrap='nowrap'
      container
      onClick={() => onSelect(listing)}
      className={`${classes.tbrTransactionListContainer} ${className}`}
      data-testid={`${testIdPrefix}${selected ? '-selected' : ''}`}
    >
      <Grid item className='fullHeight'>
        <Grid container justifyContent='flex-start' className={classes.row}>
          <Grid item xs={2} className={classes.outerDetailContainer}>
            <Grid container item xs={9}>
              <Grid item container className={classes.innerDetailInformationContainer}>
                {moment.utc(closeDateTimeUtc).format('L')}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2} className={classes.outerDetailContainer}>
            <Grid container item xs={9}>
              <Grid item container className={classes.innerDetailInformationContainer}>
                {moment
                  .utc(closeDateTimeUtc)
                  .local()
                  .format('LT')}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2} className={classes.outerDetailContainer}>
            <Grid container item xs={9}>
              <Grid item container className={classes.innerDetailInformationContainer}>
                {transactionNumber}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={1} className={classes.outerDetailContainer}>
            <Grid container item xs={9}>
              <Grid item container className={classes.innerDetailInformationContainer}>
                {touchPointId}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={1} className={classes.outerDetailContainer}>
            <Grid container item xs={9}>
              <Grid item container className={classes.innerDetailInformationContainer}>
                {siteInfoId}
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={2} className={classes.outerDetailContainer}>
            <Grid container item xs={9}>
              <Grid item container className={classes.innerDetailInformationContainer}>
                {convertCurrency(grandAmount)}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
